module.exports = __webpack_public_path__ + "img/landing.a3424bbb.png";